'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('material-ui/internal/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _WMFontIcon = require('../WMFontIcon');

var _WMFontIcon2 = _interopRequireDefault(_WMFontIcon);

var _propTypes = require('./propTypes');

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions */

var getSortIcon = function getSortIcon(sort) {
	var icon = '';

	if (sort === 'asc') {
		icon = 'arrow_upward';
	} else {
		icon = 'arrow_downward';
	}

	return icon;
};

var WMTableHeaderCell = function (_Component) {
	_inherits(WMTableHeaderCell, _Component);

	function WMTableHeaderCell() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, WMTableHeaderCell);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WMTableHeaderCell.__proto__ || Object.getPrototypeOf(WMTableHeaderCell)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			hovering: false
		}, _this.onMouseEnter = function () {
			_this.setState({ hovering: true });
		}, _this.onMouseLeave = function () {
			_this.setState({ hovering: false });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(WMTableHeaderCell, [{
		key: 'render',
		value: function render() {
			var props = this.props;
			var hovering = this.state.hovering;


			return _react2.default.createElement(
				'div',
				{
					'data-component-identifier': 'wm-table-header-cell',
					style: _styles2.default.cell(props),
					onClick: props.onHeaderClick
				},
				props.tooltip && _react2.default.createElement(
					_WMThemeProvider2.default,
					null,
					_react2.default.createElement(_Tooltip2.default, {
						label: props.tooltip,
						show: hovering,
						style: _styles2.default.tooltip(props)
					})
				),
				_react2.default.createElement(
					'span',
					{
						'data-component-identifier': 'wm-table-header-cell__content-wrapper',
						onMouseEnter: this.onMouseEnter,
						onMouseLeave: this.onMouseLeave,
						style: _styles2.default.wrapper
					},
					props.sort && _react2.default.createElement(
						_WMFontIcon2.default,
						{
							className: 'material-icons',
							id: 'table-header-cell-sort-icon__' + props.index,
							style: _styles2.default.sortIcon
						},
						getSortIcon(props.sort)
					),
					_react2.default.createElement(
						'span',
						{
							'data-component-identifier': 'wm-table-header-cell__content-children'
						},
						props.children
					)
				)
			);
		}
	}]);

	return WMTableHeaderCell;
}(_react.Component);

WMTableHeaderCell.defaultProps = _propTypes.defaultProps;

exports.default = WMTableHeaderCell;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableHeaderCell/index.js